<template>
    <div class="order-list-wrap">
        <div class="info-item" v-for="(item, index) in list" :key="index">
            <div class="info-title">
                <div class="date">{{ item.createdTime }}</div>
                <div class="order-code">
                    订单号：
                    <span>{{ item.orderNo }}</span>
                </div>
                <div class="order-state" :class="'state-' + item.orderStatus">
                    {{ item.statusInfo }}
                </div>
            </div>
            <div class="info-good">
                <div class="list-good">
                    <div class="item-good" v-for="(product_item, product_index) in item.productList" :key="product_index">
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <div class="box-title">
                                    <div class="goods-title">
                                        {{ product_item.name }}
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="box-num">{{ product_item.num }}</div>
                            </el-col>
                            <el-col :span="4">
                                <div class="box-price" v-if="product_item.price"><span style="color: orange;">￥</span>{{ product_item.price }}</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="info-heji">
                <div class="heji">
                    <div class="heji-num">
                        共 <b>{{ item.productList.length }}</b> 个商品
                    </div>
                    <div class="heji-money">
                        合计金额： <b>{{ item.price }} 元</b>
                    </div>
                </div>

                <div class="btn-actions">
                    <button class="btn-ripple fit-text" @click="toDetail(item)">订单详情</button>
                    <button class="btn-ripple fit-text" v-if="item.is_apply_price == 0" @click="doChangePrice(item)">申请改价</button>
                    <button v-if="item.ifCancel == 1" class="btn-ripple fit-text" @click="doCancel(item)">取消订单</button>
                    <button v-if="item.ifPay == 1" class="btn-ripple fit-text btn-bg" @click="doPay(item)">去支付</button>
                    <button v-if="item.ifDel == 1" class="btn-ripple fit-text btn-bg" @click="doDelete(item)">删除订单</button>
                    <button v-if="item.ifReceive == 1" class="btn-ripple fit-text btn-bg" @click="doReceive(item)">确认收货</button>
                    <!-- <button v-if="item.ifCommented == 1" class="btn-ripple fit-text btn-bg" @click="doReview(item)">去评价</button> -->
                    <!-- <button v-if="item.is_aa == 1" class="btn-ripple fit-text btn-bg" @click="toDetail(item)">查看物流</button> -->
                </div>
            </div>
        </div>

        <order_cancel_modal ref="order_cancel_modal" @confirm="emitConfirm" data-type="取消" />
        <order_delete_modal ref="order_delete_modal" @confirm="emitConfirm" data-type="删除" />
        <order_receive_modal ref="order_receive_modal" @confirm="emitConfirm" data-type="收货" />
        <!-- <order_refund_modal ref="order_refund_modal" @confirm="emitConfirm" data-type="售后" /> -->
    </div>
</template>

<script>
import order from '@/shop-actions/order'

import order_cancel_modal from '@/components/order/order_cancel_modal2.vue' //取消
import order_delete_modal from '@/components/order/order_delete_modal2.vue' //删除
import order_receive_modal from '@/components/order/order_receive_modal2.vue' //收货
import order_refund_modal from '@/components/order/order_refund_modal.vue' //售后

import { mapState } from 'vuex'

export default {
    name: 'orderList',
    components: {
        order_cancel_modal,
        order_delete_modal,
        order_receive_modal,
        order_refund_modal,
    },
    props: ['list'],
    data() {
        return {}
    },
    computed: {},
    methods: {
        emitConfirm() {
            this.$emit('confirm')
        },

        async doChangePrice(item) {
            let obj = {
                id: item.id,
            }
            let res = await this.applyPriceAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                alertSucc('申请成功')
            }
        },

        applyPriceAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drumorder_applyPrice',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },

        toDetail(item) {
            this.toRoute({
                path: '/order-detail2',
                query: {
                    id: item.id,
                },
            })
        },
        doCancel(item) {
            this.$refs.order_cancel_modal.init(item)
        },
        doPay(item) {
            this.$router.push({
                path: '/payment-methods2',
                query: {
                    id: item.id,
                },
            })
        },
        doDelete(item) {
            this.$refs.order_delete_modal.init(item)
        },
        doReceive(item) {
            this.$refs.order_receive_modal.init(item)
        },
        doReview(item) {
            console.log(item)
            // this.$router.push(`/order-review-submit?order_id=${item.id}`)
        },

        updateView() {
            this.$parent.updateView()
        },

        //处理订单行为
        handleOrderAction(action, order_id, order) {
            let fahuo_id = order.fahuo_id || ''
            //console.log({ ...action });
            let name = action.name
            if (name == '取消订单') {
                this.orders_qxOrder(order_id)
            } else if (name == '删除订单') {
                this.orders_del(order_id)
            } else if (name == '立即支付') {
                this.order_payment(order_id)
            } else if (name == '确认收货') {
                this.order_qianshou(order_id)
            } else if (name == '评价') {
                this.jump_pingjia(order_id)
            } else if (name == '申请售后') {
                this.jump_shouhou(order_id)
            } else if (name == '查看物流') {
                this.$router.push(`/orderLogistics?order_id=${order_id}&logistics_id=${fahuo_id}`)
            } else if (name == '售后') {
                this.$router.push(`/refundFeedback?order_id=${order_id}`)
            }
        },

        //取消订单
        orders_qxOrder(order_id) {
            let order = this.list.find((v) => v.id == order_id)

            // order.orders_qxOrder({
            //   params: { order_id },
            //   success: () => {
            //     this.updateView();
            //   }
            // });
        },
        //删除订单
        orders_del(order_id) {
            order.orders_del({
                params: { order_id },
                success: () => {
                    this.updateView()
                },
            })
        },
        //订单支付
        order_payment(order_id) {
            this.$router.push(`/payment-methods?order_id=${order_id}`)
        },

        //订单确认收货
        order_qianshou(order_id) {
            let order = this.list.find((v) => v.id == order_id)
            this.$refs.order_receive_modal.showModal = true
            this.$refs.order_receive_modal.order = order
            //console.log("订单信息", { ...order });
        },

        //订单评价
        jump_pingjia(order_id) {
            this.$router.push(`/order-review-submit?order_id=${order_id}`)
        },
        //订单售后申请
        jump_shouhou(order_id) {
            this.$router.push(`/orderRefund?order_id=${order_id}`)
        },
        jump_order_detail(order) {},

        open_link(link) {
            window.open(link, '_blank')
        },
    },
}
</script>

<style scoped lang="less">
.check-url {
    // margin: 15px 0;

    span {
        cursor: pointer;
        display: inlin-block;
        padding: 2px 4px;
        background: coral;
        color: #fff;
    }
}

.order-list-wrap {
    .info-item {
        border: 1px solid #e5e5e5;
        margin-bottom: 24px;
    }

    .info-title {
        .flex-between();
        height: 44px;
        padding: 0 24px;
        background: #f5f5f5;
        border-bottom: 1px solid #e5e5e5;

        .date {
            font-size: 14px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }

        .order-code {
            flex: 2;
            text-align: left;
            padding-left: 20px;

            font-size: 14px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;

            span {
                color: #333333;
            }
        }

        .order-state {
            // border: 1px solid #ccc;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #999999;
            color: #ff4d00;

            // 待付款
            &.state--5 {
                // background: #ff4c29;
                // border-color: #ff4c29;
                // color: #fff;
            }

            &.state-2 {
                color: #ff4d00;
                border-color: #ff4d00;
            }
        }
    }

    .info-good {
        .list-good {
            max-height: 300px;
            overflow-x: hidden;
            overflow-y: auto;
            .item-good {
                padding: 20px;
                border-bottom: 1px solid #e5e5e5;

                font-family: OPPOSans, OPPOSans;
                font-weight: 400;
                font-size: 14px;
                color: #333333;

                &:last-child {
                    border: none;
                }

                .box-image {
                    width: 120px;
                    height: 83px;
                    cursor: pointer;
                    border: 1px solid #f5f5f5;

                    .elImg {
                        width: 120px;
                        height: 83px;
                    }

                    // /deep/ img {
                    //     width: 120px;
                    //     height: 83px;
                    //     object-fit: contain;
                    //     object-fit: cover;
                    // }

                    // img {
                    //     width: 120px;
                    //     height: 83px;
                    //     object-fit: contain;
                    //     object-fit: cover;
                    // }
                }

                .box-title {
                    text-align: left;

                    .goods-title {
                        width: fit-content;
                        cursor: pointer;
                        color: #333333;

                        &:hover {
                            color: #ff4d00;
                        }
                    }
                }

                .box-sku {
                    text-align: start;
                }

                .box-num {
                    text-align: center;
                }

                .box-price {
                    text-align: end;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                }
            }
        }
    }

    .info-heji {
        padding: 15px 20px;
        border-top: 1px solid #e5e5e5;
        .flex-between();
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #7d7d7d;

        .heji {
            .flex();
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #333333;

            .heji-num {
                margin-right: 30px;

                b {
                    color: #ff4d00;
                }
            }

            .heji-money {
                b {
                    color: #ff4d00;
                }
            }
        }

        .btn-actions {
            button {
                transition: 0.3s;
                min-width: 120px;
                height: 32px;
                background: #ffffff;
                border: 1px solid #ff4d00;
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 14px;
                color: #ff4d00;

                & + button {
                    margin-left: 20px;
                }

                &:hover {
                    opacity: 0.7;
                }

                &.btn-bg {
                    background: #ff4d00;
                    color: #ffffff;
                }
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/shop/orderList.less"></style>
